export const skills = [
  { name: 'Java', skill: '99%' },
  { name: 'React', skill: '90%' },
  { name: 'HTML & CSS', skill: '90%' },
  { name: 'JavaScript', skill: '85%' },
  { name: 'React Native', skill: '85%' },
  { name: 'Python', skill: '85%' },
];
